const path = '$webpart'

export const WEBPART_COMMONDATA_MOUNTED = `${path}/webpart/commonDataMounted`
export const WEBPART_COMMONDATA = `${path}/webpart/commonData`
export const WEBPART_UNREADMAIL_DATA = `${path}/webpart/unreadMailData`
export const WEBPART_UNREADMAIL_COUNT_DATA = `${path}/webpart/unreadMailCountData`

export const WEBPART_CALENDARFOLDER_DATA = `${path}/webpart/calendarFolderData`
export const WEBPART_CALENDARDAILYEVENT_DATA = `${path}/webpart/calendarDailyEventData`
export const WEBPART_CALENDARTODAYEVENT_DATA = `${path}/webpart/calendarTodayEventData`
export const WEBPART_CALENDARMONTHLYEVENT_DATA = `${path}/webpart/calendarMonthlyEventData`